import { PaginationType } from 'constants/Global';
import type { Action, Page, PageContent } from 'modules/global/generic.types';
import { createReducer } from 'utils/ReduxUtils';

import type { WrapperReducerConfig } from './reducers.types';
import { isSuccessRequest, isFailureRequest } from './utils';

export const initialState: Page = {
  number: 0,
  totalElements: 0,
  totalPages: 0,
  size: 10,
  type: PaginationType.PAGE,
};

const setAll = (_: Page, { payload }: Action<PageContent<Record<string, unknown>>>): Page =>
  payload?.page ?? ({} as Page);

const clearAll = (): Page => initialState;

const genericPageReducer = (actionRoot: string, { reducers = {}, matchers = [], global: config }: WrapperReducerConfig<Page> = {}) =>
  createReducer(initialState, reducers, [
    {
      matcher: isSuccessRequest(actionRoot, config ?? {}),
      reducer: setAll,
    },
    {
      matcher: isFailureRequest(actionRoot, config ?? {}),
      reducer: clearAll,
    },
    ...matchers,
  ]);

export default genericPageReducer;
